import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';

const Dashboard = () => {
  const sections = [
    {
      icon: '⚓',
      title: 'Alfred Thayer Mahan',
      links: [
        { to: '/mahan01', label: 'Análisis Estratégico: El Poder Naval (1660-1783)' },
        { to: '/mahan02', label: 'La Filosofía del Poder Naval' }
      ]
    },
    {
      icon: '🌍',
      title: 'Halford Mackinder',
      links: [
        { to: '/mackinder', label: 'El Teorema del Heartland' },
        { to: '/mackinder01', label: 'El Pivote Geográfico (1904)' },
        { to: '/mackinder02', label: 'Revisión de 1919' },
        { to: '/mackinder03', label: 'Aplicaciones Históricas' },
        { to: '/mackinder05', label: 'Futuro del Heartland' },
        { to: '/mackspyman04', label: 'Mackinder vs Spykman' }
      ]
    },
    {
      icon: '🗺️',
      title: 'Nicholas Spykman',
      links: [
        { to: '/spykman', label: 'Teoría del Rimland' },
        { to: '/rimland2', label: 'Doctrina de Contención' },
        { to: '/heartland-leaflet', label: 'Mapa Interactivo' }
      ]
    },
    {
      icon: '🎯',
      title: 'Kenneth Waltz',
      links: [
        { to: '/waltz', label: 'Teoría de la Política Internacional' }
      ]
    },
    {
      icon: '📝',
      title: 'Blog',
      links: [
        { to: '/blog', label: 'Ver Blog de Geopolítica' }
      ]
    },
    {
      icon: '🛡️',
      title: 'Seguridad Nacional',
      links: [
        { to: '/seguridad-nacional-2025', label: 'Estrategia 2025: Análisis Interactivo' },
        { to: '/seguridad-nacional-analisis', label: 'Análisis Crítico: El Nuevo Mapa Imperial' },
        { to: '/sistema-defensivo', label: 'Sistema Defensivo Integrado' }
      ]
    }
  ];

  return (
    <div className="container">
      <Header 
        title="Geo vs Astro" 
        subtitle="Panel de Control Principal" 
      />
      
      <div className="grid">
        {sections.map((section, index) => (
          <article key={index} className="card">
            <div className="card-header">
              <div className="icon">{section.icon}</div>
              <h2>{section.title}</h2>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              {section.links.length > 0 ? (
                section.links.map((link, i) => (
                  <Link key={i} to={link.to} className="link-item">
                    {link.label}
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" style={{ width: '20px', height: '20px', marginLeft: 'auto' }}>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                  </Link>
                ))
              ) : (
                <p style={{ color: '#94a3b8', fontStyle: 'italic', textAlign: 'center', padding: '1rem' }}>
                  {section.empty}
                </p>
              )}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
